/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider'
import * as Styled from './Flyouts.styles'

const links = {
  termspdf: '//documents.4rgos.it/v1/static/ArgosCard_TermsAndConditions_ImportantCardholderInformation_29-9_39-9_34-9'
}

export const flyoutCreditPlan = (trackClick) => {
  const { CREDIT_URL, BRAND_NAME } = useVocab()

  return (
    <Styled.Flyout>
      <h3>What Argos Card credit plans are available at the checkout?</h3>
      <Styled.FlyoutParagraph>
        You can buy anything from {BRAND_NAME} with an Argos Card. We also have longer credit plans which range from
        3-12 months depending on how much you spend. You’ll find our latest plan offers&nbsp;
        <a className='a' target='_blank' onClick={() => trackClick()} href={CREDIT_URL} data-test='m023-offers-link'>
          here.
        </a>
      </Styled.FlyoutParagraph>
      <h3>Am I eligible for an Argos Card credit plan?</h3>
      <Styled.FlyoutParagraph>
        You can apply if you're over 18, have been a permanent UK resident for over 1 year and can provide addresses for
        the past 2 years and your bank details. We treat all our customers and their applications on an individual
        basis. The APR we offer is determined by the details you supply and the credit you are applying for, along with
        an independent verification of your credit and repayment history and will range from 34.9% to 39.9% APR.
      </Styled.FlyoutParagraph>
      <h3>What's buy now, pay later?</h3>
      <Styled.FlyoutParagraph>
        This gives you a period of time to repay the cost of your purchase. No interest will be charged if you pay in
        full within your credit plan period and keep your account up-to-date.
      </Styled.FlyoutParagraph>
      <h3>How does buy now, pay later interest work?</h3>
      <Styled.FlyoutParagraph>
        If you don’t pay in full, in the agreed time, you’ll be charged interest on any balance remaining at the end of
        the plan. This interest will be backdated to the date you made the purchase.
      </Styled.FlyoutParagraph>
      <h3>What's normal credit?</h3>
      <Styled.FlyoutParagraph>
        Normal credit works in the same way as a standard credit card. If you clear your balance before your next
        statement date, you'll incur no interest. Your monthly statement will show how much you owe and the date you
        need to pay it by.
      </Styled.FlyoutParagraph>
      <Styled.MiddleSeperator> </Styled.MiddleSeperator>
      <h3>How do I take out an Argos Card credit plan?</h3>
      <Styled.FlyoutList>
        <Styled.FlyoutListItem>
          We'll remind you to apply for an Argos Card credit plan when you check out.
        </Styled.FlyoutListItem>
        <Styled.FlyoutListItem>So now just add what you want to your trolley...</Styled.FlyoutListItem>
      </Styled.FlyoutList>
      <Styled.TC>
        <p>
          Credit is subject to status.&nbsp;
          <a className='a' target='_blank' href={links.termspdf}>
            T&Cs apply
          </a>
        </p>
      </Styled.TC>
    </Styled.Flyout>
  )
}

export const flyoutFastTrack = () => (
  <Styled.Flyout>
    <h3>How does Fast Track delivery work?</h3>
    <Styled.FlyoutParagraph>
      With our awesome Fast Track service, you can get same day delivery for just £4.95. It’s available 7 days a week
      for thousands of products. Result!
    </Styled.FlyoutParagraph>
    <h3>Start by buying online</h3>
    <Styled.FlyoutParagraph>
      Pay for your order via our website or app by 5pm - and we’ll deliver by 10pm, subject to availability. (Who else
      can do that?)
    </Styled.FlyoutParagraph>
    <h3>Your choice of timeslots</h3>
    <Styled.FlyoutParagraph>
      With a choice of delivery slots your items will be left in a safe and sensible location at your doorstep, so you
      don’t have to spend all day waiting indoors. And... if you give us your mobile number, we’ll give you a 2-hour
      delivery window (we’re nice like that).
    </Styled.FlyoutParagraph>
  </Styled.Flyout>
)

export const flyoutClickandCollect = () => (
  <Styled.Flyout>
    <h3>Pay now & you'll get longer to collect</h3>
    <Styled.BulletPadding>
      <Styled.BulletList>Pop in anytime, we'll hold your item(s) for 7 days</Styled.BulletList>
      <Styled.BulletList>Skip the payment queue and save time in-store</Styled.BulletList>
      <Styled.BulletList>Plus, log into Your Account online to extend for another week</Styled.BulletList>
    </Styled.BulletPadding>
    <p> </p>
    <h3>Reserve now & pay when you collect</h3>
    <Styled.BulletPadding>
      <Styled.BulletList>You don’t have to pay anything up-front</Styled.BulletList>
      <Styled.BulletList>But we'll still hold your item(s) for up to 2 days</Styled.BulletList>
      <Styled.BulletList>And you can pay either way - card or cash</Styled.BulletList>
    </Styled.BulletPadding>
  </Styled.Flyout>
)
